import { apiSlice } from "core/api"
import { makeCrudEndpoints } from "common/api/apiHelpers"
import { BingoTemplate } from "bingo/types/bingo-template.model"

const api = apiSlice.injectEndpoints({
  endpoints: makeCrudEndpoints<"BingoTemplate", BingoTemplate>("BingoTemplate", "bingo-templates"),
})

export const {
  useGetBingoTemplateQuery,
  useListBingoTemplatesQuery,
  useAddBingoTemplateMutation,
  useRemoveBingoTemplateMutation,
  useUpdateBingoTemplateMutation,
} = api